import classNames from "classnames";
import React from "react";
import styles from "../assets/styles/components/SelectionBar.module.scss";

interface Item<ValueType> {
  label: string;
  value: ValueType;
}

interface Props<ValueType> {
  firstSelection: Item<ValueType>;
  secondSelection: Item<ValueType>;
  value?: ValueType;
  onChange: (value: ValueType) => void;
}

export const SelectionBar: React.FC<Props<any>> = ({
  firstSelection,
  secondSelection,
  value,
  onChange,
}) => {
  const firstSelected = value === firstSelection.value;
  const secondSelected = value === secondSelection.value;

  return (
    <div className={styles.selectionBar} data-testid="selectCustomerType">
      <div
        onClick={() => onChange(firstSelection.value)}
        className={classNames(
          styles.firstSelection,
          firstSelected && styles.blue
        )}
      >
        {firstSelection.label}
      </div>
      <div
        onClick={() => onChange(secondSelection.value)}
        className={classNames(
          styles.secondSelection,
          secondSelected && styles.blue
        )}
      >
        {secondSelection.label}
      </div>
    </div>
  );
};
